export const QuillStyleClasses = {
  'ql-align-center': { textAlign: 'center' as const },
  'ql-align-right': { textAlign: 'right' as const },
  'ql-align-justify': { textAlign: 'justify' as const },
  'ql-indent-1': { paddingLeft: 40 },
  'ql-indent-2': { paddingLeft: 80 },
  'ql-indent-3': { paddingLeft: 120 },
  'ql-indent-4': { paddingLeft: 160 },
  'ql-indent-5': { paddingLeft: 200 },
  'ql-indent-6': { paddingLeft: 240 },
  'ql-indent-7': { paddingLeft: 280 },
  'ql-indent-8': { paddingLeft: 320 },
}
